import { MachineType } from '../../../interfaces/Brand.interfaces';
import { IOpenMarketProduct } from '../../../interfaces/OpenMarketProduct.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export interface IGetUserSellTractorsParams {
  searchParam: {
    machineType?: MachineType | '';
  };
}

export const getUserSellTractors = ({ searchParam }: IGetUserSellTractorsParams): Promise<IOpenMarketProduct[]> => {
  const URLSearchParams = createURLSearchParams(searchParam);
  return customAxios.get(`/user-sell-tractors/mine?${URLSearchParams}`);
};
